import Mask from '../../../components/Mask';
import s from './ReStart.module.scss';
import { Button } from 'antd';
const ReStartModal = (props) => {
    const { onClose, show, onConfirm, loading } = props;

    return (
        <Mask show={show}>
            <div className={s.modalWrap}>
                <div className={s.modalContentWrap}>
                    <div className={s.modalContent}>
                        <div className={s.modalContentText}>请确认是否重新开始</div>
                        <div className={s.modalContentBtn}>
                            <Button shape="round" className={s.modalContentBtnCancel} onClick={onClose}>
                                取消
                            </Button>
                            <Button shape="round" type="primary" className={s.modalContentBtnConfirm} loading={loading} onClick={onConfirm}>
                                确定
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Mask>
    );
};

export default ReStartModal;
